import { a as __rest } from '../../tslib.es6.esm.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import React__default, { useMemo } from 'react';
import { Item } from '@radix-ui/react-accordion';
import { Divider } from '../Divider/Divider.esm.js';
import accordionStyles from './Accordion.styles.esm.js';
import { useAccordionContext } from './AccordionContext.esm.js';
import { cn } from '../../utils/cn.esm.js';

// Create AccordionItem subcomponent
const AccordionItem = React__default.forwardRef((_a, ref) => {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    // Access context
    const { variant, inverse, showTopDivider } = useAccordionContext();
    const isUncontained = variant === "uncontained";
    const { item } = useMemo(() => accordionStyles({
        variant,
        inverse,
    }), [variant, inverse]);
    return (jsxs(Item, Object.assign({ ref: ref, className: cn(item(), className) }, props, { children: [showTopDivider && isUncontained && jsx(Divider, { inverse: !!inverse }), children, isUncontained && jsx(Divider, { inverse: !!inverse })] })));
});

export { AccordionItem };
